import { render, staticRenderFns } from "./list-notification.vue?vue&type=template&id=3e4ea4b6&scoped=true&"
import script from "./list-notification.vue?vue&type=script&lang=ts&"
export * from "./list-notification.vue?vue&type=script&lang=ts&"
import style0 from "./list-notification.vue?vue&type=style&index=0&id=3e4ea4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ea4b6",
  null
  
)

export default component.exports